export default class ConversationUtil {
  constructor(data) {
    this.dealerId = data.dealerId
    this.dealerName = data.dealerName
    this.adId = data.adId
    this.adUrl = data.adUrl
    this.popUpZIndex = data.popUpZIndex
    this.pageUrlOverride = data.pageUrlOverride
    this.realmId = data.realmId
  }
}
